import useUberOrderDeny from "@/shared/hooks/useUberOrderDeny";
import { DenyReason, rejectionOptions } from "@/shared/utils/uber";
import { OrderV2 } from "@/shared/v2/queries/interfacesV2";
import { Controller, useForm } from "react-hook-form";
import { useTranslation } from "react-i18next";
import Button from "../Button/Button";
import Textarea from "../Input/Textarea";
import Select from "../Select/Select";
interface Props {
  order: OrderV2;
}
const DenyUberOrder = ({ order }: Props) => {
  const mutation = useUberOrderDeny({
    id: order.order_information.item_id,
    branchId: order.order_information.branch_id,
  });
  const { t } = useTranslation();
  const { handleSubmit, errors, register, control } = useForm();
  const onSubmit = (data: DenyReason) => {
    return mutation.mutate(data);
  };
  return (
    <form onSubmit={handleSubmit(onSubmit)} className="mt-[2rem]">
      <Controller
        name="deny_type"
        control={control}
        rules={{
          required: true,
        }}
        render={(props) => (
          <Select
            styles={{
              menuPortal: (base) => ({
                ...base,
                zIndex: 9999,
              }),
            }}
            menuPlacement="top"
            menuPortalTarget={document.getElementById("root")}
            error={errors?.type?.message}
            options={rejectionOptions}
            getOptionLabel={(option) => `${t(option.label)}`}
            placeholder={t("reason")}
            value={rejectionOptions.find(
              (option) => option.value === props.value
            )}
            onChange={(e) => {
              props.onChange(e.value);
            }}
          ></Select>
        )}
      />
      <div className="my-[2rem]">
        <Textarea
          width="100%"
          ref={register({
            required: {
              value: true,
              message: t("fieldRequired"),
            },
          })}
          error={errors?.info?.message}
          placeholder={t("explanation")}
          name="deny_reason"
        />
      </div>
      <Button
        isDisabled={mutation.isPending}
        isPending={mutation.isPending}
        variant="danger"
      >
        {t("denyOrder")}
      </Button>
    </form>
  );
};
export default DenyUberOrder;
